













































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Apps from '@/store/modules/Apps';
import { Urls } from "@/Urls";
import { type } from "os";

const appsModule = getModule(Apps);

@Component({
    name: 'DecisionManagerAppletMenu',

})
export default class DecisionManagerAppletMenu extends Vue {
    @Prop()
    decisionId: string;

    private applets = [];

    mounted() {
        this.decisionApplets();
    }

    private async decisionApplets() {
        this.applets = await appsModule.checkAppsByDecision(this.decisionId);
    }

    private getAppsUrl(url: string) {

        let mainPath = Urls.APP_EMBED;
        // Remove trailing '/' if there
        mainPath = mainPath.charAt(mainPath.length - 1) == '/' ? 
            mainPath.substr(0, mainPath.length - 1) : mainPath

        let re = new RegExp(
            '^(http:|https:){1}[/]{2}([a-zA-Z0-9.:-]*[/]{0})([/]{1}[/]*){1}'
        );
        if (re.test(url)) {
            url = mainPath + url.replace(re, '/');
            // console.log(url);
            return url;
        } else {
            // console.log(url);
            return mainPath + url;
        }
    }

    private generateLink(item: any) {

        let link = window.location.origin;
        if(item.children && item.children.length > 0) {
            link = `${link}${this.getAppsUrl(item?.children[0].href)}`;
            link = `${link}&homepage=${item.homepage && item.showHomepage}&pinnedLeft=true&appEmbedId=${item.id}&appEmbedMenuId=${item.id}`
            return link
        }
        
    }

}
